import $ from "jquery";

const initVinLookupToggle = () => {
  $(".js-year-select").on("select2:select", function (_) {
    if ($(".js-year-select").val() < 1989) {
      $(".js-vin-lookup-btn").addClass("d-none");
    } else {
      $(".js-vin-lookup-btn").removeClass("d-none");
    }
  });
};

export { initVinLookupToggle };
